import type { ThemeDefinition } from './types';

export const modernDark: ThemeDefinition = {
  fontsUrl: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap',
  variables: {
    '--report-font-display': "'Inter', system-ui, sans-serif",
    '--report-font-body': "'Inter', system-ui, sans-serif",
    '--report-bg': '#0f172a',
    '--report-bg-surface': '#1e293b',
    '--report-text': '#f1f5f9',
    '--report-text-secondary': '#94a3b8',
    '--report-text-muted': '#64748b',
    '--report-accent': '#38bdf8',
    '--report-accent-dim': 'rgba(56, 189, 248, 0.12)',
    '--report-border': '#334155',
    '--report-border-strong': '#475569',
    '--report-stat-color': '#f1f5f9',
    '--report-stat-positive': '#4ade80',
    '--report-stat-negative': '#f87171',
    '--report-callout-bg': '#1e293b',
    '--report-callout-border': '#38bdf8',
    '--report-surface-hover': '#273549',
    '--report-code-bg': '#1e293b',
    '--report-code-text': '#38bdf8',
    '--report-measure': '780px',
  },
};
